import React, { useState } from 'react'
import styled from 'styled-components'
import { FiMapPin } from 'react-icons/fi'
import { shopLocation, useShopLocation } from '../../utils/shopLocation'
import theme from '../../theme'

const LocationBar: React.FC<{ onDark?: boolean }> = ({ onDark }) => {
  const { location } = useShopLocation()
  const [editing, setediting] = useState(false)
  const [query, setquery] = useState('')
  const [error, seterror] = useState('')
  const [busy, setbusy] = useState(false)

  const apply = async () => {
    if (!query.trim()) return
    setbusy(true)
    seterror('')
    const problem = await shopLocation.choose(query.trim())
    setbusy(false)
    if (problem) seterror(problem)
    else {
      setediting(false)
      setquery('')
    }
  }

  return (
    <Bar $onDark={!!onDark}>
      <FiMapPin />
      {!editing ? (
        <>
          <span>{location ? `${location.city}${location.state ? `, ${location.state}` : ''}` : 'Locating you...'}</span>
          <LinkButton $onDark={!!onDark} onClick={() => setediting(true)}>Change</LinkButton>
          {location && location.source === 'chosen' && (
            <LinkButton $onDark={!!onDark} onClick={() => shopLocation.useMyLocation()}>Use my location</LinkButton>
          )}
        </>
      ) : (
        <>
          <Input
            autoFocus
            placeholder="City or zip code"
            value={query}
            onChange={(e) => setquery(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') apply() }}
          />
          <LinkButton $onDark={!!onDark} onClick={apply} disabled={busy}>{busy ? '...' : 'Set'}</LinkButton>
          <LinkButton $onDark={!!onDark} onClick={() => { setediting(false); seterror('') }}>Cancel</LinkButton>
          {error && <ErrorText>{error}</ErrorText>}
        </>
      )}
    </Bar>
  )
}

const Bar = styled.div<{ $onDark: boolean }>`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;
  padding: 6px 14px;
  border-radius: 999px;
  background: ${(p) => (p.$onDark ? 'rgba(255,255,255,0.14)' : theme.colors.surface)};
  color: ${(p) => (p.$onDark ? '#fff' : theme.colors.text)};
  border: 1px solid ${(p) => (p.$onDark ? 'rgba(255,255,255,0.25)' : theme.colors.border)};
`

const LinkButton = styled.button<{ $onDark: boolean }>`
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;
  color: ${(p) => (p.$onDark ? '#cfe4ff' : theme.colors.primary)};
`

const Input = styled.input`
  border: none;
  outline: none;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  width: 150px;
`

const ErrorText = styled.span`
  color: #ffb4c2;
  font-size: 12px;
`

export default LocationBar
